import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { ReactElement } from 'react';

import { useGetOne, useRecordContext } from 'react-admin';
import { Typography } from 'shared/mui/Typography';
import { convertReactAdminIdToHydraId, formatCurrency } from 'utils';

type Props = {
  label?: string | ReactElement | boolean;
  source?: string;
};

export const RefundChargebackReportTotalAmountField: React.FC<Props> = () => {
  const record = useRecordContext();
  const { data: currency } = useGetOne(
    Resources.Currencies,
    { id: convertReactAdminIdToHydraId(record?.currency.id, Resources.Currencies) },
    { enabled: !!record },
  );

  if (!record || !record?.totalAmount) {
    return EMPTY_FIELD;
  }

  return (
    <>
      <Typography component="span" variant="body2">
        {formatCurrency(record?.totalAmount)}
      </Typography>{' '}
      <Typography component="span" sx={{ fontWeight: 500 }} variant="body2">
        {currency?.alphaCode}
      </Typography>
    </>
  );
};
